// Generated by purs version 0.15.15
import * as Ouroboros_Models_Documents_ReviewSectionsPhase from "../Ouroboros.Models.Documents.ReviewSectionsPhase/index.js";
import * as Ouroboros_Models_Ui_VisibilityPhase from "../Ouroboros.Models.Ui.VisibilityPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_DocumentReview from "../Ouroboros.Programs.Controllers.DocumentReview/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var mkDocumentReviewEnv = function (input) {
    return {
        loading: input.kernel.loading,
        navigate: input.kernel.navigate,
        promptRoute: input.kernel.promptRoute,
        reviewRouteWithDocument: input.kernel.reviewRouteWithDocument,
        document: input.kernel.document,
        activeSection: input.kernel.activeSection,
        modalVisible: input.kernel.modalVisible,
        newSectionTitle: input.kernel.newSectionTitle,
        sectionTitleError: input.kernel.sectionTitleError,
        appendSectionState: input.kernel.appendSectionState,
        generateSectionQuestions: input.kernel.generateSectionQuestions,
        appendSection: input.kernel.appendSection,
        uploadSupplementalDocument: input.kernel.uploadSupplementalDocument,
        downloadDocumentAsBlob: input.kernel.downloadDocumentAsBlob,
        fetchDocumentById: input.kernel.fetchDocumentById,
        downloadHandler: input.kernel.downloadHandler,
        taskRunner: input.kernel.taskRunner,
        routeDocumentId: input.routeDocumentId,
        documentSelectionRoute: input.documentSelectionRoute,
        refineRoute: input.refineRoute,
        finalEditsRoute: input.finalEditsRoute,
        reviewRoute: input.reviewRoute,
        selectUploadPayload: input.selectUploadPayload,
        uploadSuccessToast: input.uploadSuccessToast
    };
};
var buildDocumentReviewViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentReview.mkDocumentReviewController(mkDocumentReviewEnv(input));
    return {
        onBack: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.onBack);
        },
        onInit: controller.onInit,
        onOpenModal: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.onOpenModal);
        },
        onDownload: Ouroboros_Services_Clients_Interop_Option.map(function (action) {
            return function (v) {
                return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(action);
            };
        })(controller.onDownload),
        reviewSectionsPhase: Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Models_Documents_ReviewSectionsPhase.reviewSectionsPhaseNamespace.hidden;
        })(function (v) {
            return Ouroboros_Models_Documents_ReviewSectionsPhase.reviewSectionsPhaseNamespace.visible;
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.document))),
        handleDraft: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.handleDraft);
        },
        handleRefine: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.handleRefine);
        },
        handleEdits: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.handleEdits);
        },
        handleUpload: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.handleUpload);
        },
        newSectionModalPhase: (function () {
            var $18 = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.modalVisible));
            if ($18) {
                return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.visible;
            };
            return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.hidden;
        })(),
        closeModal: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.closeModal);
        },
        newSectionTitle: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.newSectionTitle)),
        setNewSectionTitle: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.newSectionTitle))(value);
        },
        sectionTitleErrorPhase: Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.hidden;
        })(function (v) {
            return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.visible;
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.sectionTitleError))),
        sectionTitleErrorMessage: Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return "";
        })(function (message) {
            return message;
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.sectionTitleError))),
        handleSubmitNewSection: function (v) {
            return Ouroboros_Programs_Controllers_DocumentReview.runDocumentReviewAction(controller.handleSubmitNewSection(readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.newSectionTitle))));
        }
    };
};
export {
    buildDocumentReviewViewProps
};
//# sourceMappingURL=index.js.map
